"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 4H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 6H8V6h6v4z"];
//# sourceMappingURL=segmented-control.js.map